const pointAllocation: Record<number, number> = {
	1: 10,
	2: 7,
	3: 5,
	4: 3,
	5: 2,
	6: 1,
	7: 1,
	8: 1,
};

export default pointAllocation;
